
import { mapGetters } from 'vuex';
import Service from '../../account-info.service.js';
import { errorMessage } from '@/utils/message.js';
export default {
  props: {
    userType: {
      type: Number,
      default: 1
    },
    basicInfo: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      enterpriseNatureList: []  // 企业性质列表
    };
  },

  computed: mapGetters(['isHeilongjiang']),
  created() {
    // 获取字典：企业性质列表
    this.$store.dispatch('getSelectDictList', 'ENTERPRISE_NATURE').then(res => {
      if (res.code === '0') {
        this.enterpriseNatureList = res.data;
      }
    });
  },

  methods: {
    updateVillageInfo() {
      Service.updateNamecheck().then(res => {
        if (res && res.code === '0') {
          this.$router.push({
            path: '/person-center/account-info/modify-village-name',
            query: { creditCode: this.basicInfo.creditCode }
          });
        } else {
          errorMessage(res.reason);
        }
      }, error => {
        if (error && error.data && error.data.reason) {
          errorMessage(error.data.reason);
        }
      });
    }
  }
};
